import {
    REQUEST_STATE,
    CORE_GET_OIL_PRICES_REQUEST,
    CORE_GET_OIL_PRICES_SUCCESS,
    CORE_GET_OIL_PRICES_FAILURE,
} from '../types'

const requestState = REQUEST_STATE

export default {
    oilPrices: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_OIL_PRICES_REQUEST:
                return state
            case CORE_GET_OIL_PRICES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_GET_OIL_PRICES_FAILURE:
                return []
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/testOilPrice.js